import React from "react";
import { Button } from "antd";
import { Row, Col, Form, Select, Input, Spin } from "antd";
import FileDrop from "react-file-drop";

import { ALL_PURPOSE_OF_TRANSFER_VALUES } from "domain/PurposeOfTransfer";
import "./SetupSourceOfFundsTab.scss";
import {displayGenericError} from "../../common/notifications";
import {geRemittanceCode} from "../../api/api";
import { formatMoneyValue, formatMoney, formatExchangeRate } from "utils/utils";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class SetupSourceOfFundsTab extends React.Component {
  state = {
    purposeOfTransfers:[]
  }
  constructor(props) {
    super(props);
    this.fileUploader = React.createRef();
    this.state = {
      purposeOfTransfer: null,
      noteToBeneficiaryText: null,
      invoiceFileName: null,
      invoiceUploading: false,
      purposeOfTransfers:[]
    };
  }
  componentDidMount() {
    geRemittanceCode().then(response => {
      response = response.filter(item => item.value != "Other")
      this.setState({
        purposeOfTransfers: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
  }
  isFormValid() {
    if (!this.state.purposeOfTransfer) {
      return false;
    }
    return true;
  }

  onPurposeOfTransferChanged = newValue => {
    this.setState({
      purposeOfTransfer: newValue
    });
    this.props.onPurposeOfTransferChanged(newValue)
  };

  onReferenceTextChanged = newValue => {
    this.setState({
      referenceText: newValue
    });
  };

  onInternalReferenceTextChanged = newValue => {
    this.setState({
      internalReference: newValue
    });
  };

  onUploadedFileChanged = event => {
    let file = event.target.files[0];
    this.setState({
      invoiceUploading: true
    });
    this.props.onUploadInvoice(file)
        .then( invoiceFileName => {
          this.setState({
            invoiceUploading: false,
            invoiceFileName: invoiceFileName
          })
        })
  };
  handleInvoiceDrop = (files, event) => {
    this.setState({
      invoiceUploading: true
    });
    this.props.onUploadInvoice(files[0])
      .then( invoiceFileName => {
        this.setState({
          invoiceUploading: false,
          invoiceFileName: invoiceFileName
        })
      })
  };

  handleUploadClick = () => {
    this.fileUploader.current.click();
  };

  render() {
    const intl = this.props.useIntl;
    return (
      <>
        <div className="bp-page-body ">
          <div className="bp-bordered-panel">
            <Row className="bp-row" gutter={16}>
              <Col md={12} xs={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.setupsourceoffundstab.sendamount"})}
                  value={formatMoneyValue(this.props.payment.sourceValue)}
                />
              </Col>
              <Col md={12} xs={12}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.setupsourceoffundstab.beneficiarygets"})}
                  value={formatMoneyValue(this.props.payment.targetValue)}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="bp-page-body source-of-funds">
          <Form>
            <Form.Item label={intl.formatMessage({id: "app.panel.setupsourceoffundstab.purposeoftransfer"})} required="true">
              {/*<Select*/}
              {/*  size={"large"}*/}
              {/*  value={this.state.purposeOfTransfer}*/}
              {/*  onChange={this.onPurposeOfTransferChanged}*/}
              {/*  style={{ width: "100%" }}*/}
              {/*>*/}
              {/*  {ALL_PURPOSE_OF_TRANSFER_VALUES.map(record => {*/}
              {/*    return (*/}
              {/*      <Select.Option key="idx" value={record.value}>*/}
              {/*        {record.name}*/}
              {/*      </Select.Option>*/}
              {/*    );*/}
              {/*  })}*/}
              {/*</Select>*/}
              <Select
                  value={this.state.purposeOfTransfer}
                  size={"large"}
                  onChange={this.onPurposeOfTransferChanged}
                  style={{width: "100%"}}>
                  {this.state.purposeOfTransfers.map((record, idx) => {
                    return <Select.Option key="idx" value={record.code}>{record.value}</Select.Option>
                  })}
              </Select>
            </Form.Item>
          </Form>
          <Form>
            <Form.Item label={intl.formatMessage({id: "app.panel.setupsourceoffundstab.messagetobeneficiary"})}>
              <Input
                size={"large"}
                value={this.state.referenceText}
                onChange={event =>
                    this.onReferenceTextChanged(event.target.value)
                }
              />
            </Form.Item>
          </Form>
          <Form>
            <Form.Item label={intl.formatMessage({id: "app.panel.setupsourceoffundstab.internalreference"})}>
              <Input
                size={"large"}
                value={this.state.internalReference}
                onChange={event =>
                  this.onInternalReferenceTextChanged(event.target.value)
                }
              />
            </Form.Item>
          </Form>
          {/*
          
          <Form>
            <Form.Item label="Upload Invoice (optional)">
              <Spin disable={true} spinning={this.state.invoiceUploading}>
                <div className="bp-margin-top-smallest">
                  <input
                    type="file"
                    id="file"
                    ref={this.fileUploader}
                    style={{ display: "none" }}
                    onChange={this.onUploadedFileChanged}
                    disabled={true}
                  />
                  <FileDrop onDrop={this.handleInvoiceDrop}>
                    <Button
                      disabled={true}
                      className="dropzone-button"
                      onClick={this.handleUploadClick}
                    >
                      {this.state.invoiceFileName ? (
                        this.state.invoiceFileName
                      ) : (
                        <div>
                          <span className={"icon"}>
                            <svg
                              width="29"
                              height="27"
                              viewBox="0 0 29 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M20.9312 2.16658C22.3242 3.42364 23.235 5.08015 23.5446 6.89525C26.664 7.70588 28.944 10.6371 28.95 13.9325C28.95 15.7534 28.2654 17.5039 27.0093 18.8667C25.7472 20.2413 24.0506 21.0636 22.2349 21.1929H22.1754H17.7581C17.3117 21.1929 16.9545 20.8404 16.9545 20.3999C16.9545 19.9593 17.3117 19.6069 17.7581 19.6069H22.1456C25.015 19.3895 27.3427 16.8519 27.3427 13.9325C27.3427 11.1775 25.3424 8.76322 22.6933 8.31679C22.3361 8.25805 22.0622 7.97021 22.0265 7.6119C21.6932 4.16965 18.794 1.57329 15.2816 1.57329C12.6682 1.57329 10.2632 3.07707 9.14994 5.4091C8.97134 5.77917 8.53677 5.95539 8.14386 5.81441C7.82239 5.69693 7.47711 5.63819 7.12588 5.63819C5.48282 5.63819 4.14337 6.95987 4.14337 8.58113C4.14337 8.93945 4.2029 9.27427 4.32196 9.59148C4.45293 9.95567 4.31006 10.361 3.97073 10.5548C2.51221 11.3948 1.60734 12.9456 1.60734 14.608C1.60734 17.1809 3.65521 19.4659 6.09004 19.6127H11.1859C11.6324 19.6127 11.9896 19.9652 11.9896 20.4057C11.9896 20.8463 11.6324 21.1988 11.1859 21.1988H6.06622H6.0186C4.39935 21.1106 2.88131 20.3529 1.73236 19.0723C0.613171 17.8211 0 16.241 0 14.6139C0 12.599 0.99417 10.7076 2.63128 9.53273C2.57175 9.22728 2.53603 8.91595 2.53603 8.59287C2.53603 6.09637 4.59581 4.06392 7.12588 4.06392C7.42354 4.06392 7.72119 4.09329 8.00694 4.14616C8.66774 3.00658 9.60238 2.03735 10.7275 1.3207C12.0789 0.457207 13.6564 -0.000976562 15.2757 -0.000976562C17.3712 -0.000976562 19.3833 0.768532 20.9312 2.16658ZM19.3001 14.2445C19.6156 14.5559 19.6156 15.0552 19.3001 15.3665C18.9846 15.6778 18.4786 15.6778 18.169 15.3665L15.2818 12.5175V25.611C15.2818 26.0515 14.9246 26.404 14.4781 26.404C14.0316 26.404 13.6744 26.0515 13.6744 25.611V12.5175L10.7872 15.3665C10.6324 15.5251 10.424 15.6015 10.2216 15.6015C10.0192 15.6015 9.81085 15.5192 9.65607 15.3665C9.34056 15.0552 9.34056 14.5559 9.65607 14.2445L13.9125 10.0445C14.0614 9.89181 14.2697 9.80957 14.4781 9.80957C14.6865 9.80957 14.8948 9.89768 15.0436 10.0445L19.3001 14.2445Z"
                                fill="#9B9B9B"
                              />
                            </svg>
                          </span>
                          Drag your invoice here or
                          <span className={"text-link"}> browse</span>
                        </div>
                      )}
                    </Button>
                  </FileDrop>
                </div>
              </Spin>
            </Form.Item>
          </Form>

         */}
        </div>
        <div className="bp-padded-top-panel bp-buttons-panel">
          <Button
            size="large"
            className="bt-skip btn-wide-md"
            onClick={this.props.onBack}
            htmlType={"button"}
          >
            <FormattedMessage id="app.panel.setupsourceoffundstab.back"/>
          </Button>
          <Button
            htmlType={"button"}
            type="primary"
            size="large"
            disabled={!this.isFormValid()}
            className="btn-wide-md"
            onClick={() =>
              this.props.onCompleted(
                this.state.purposeOfTransfer,
                this.state.referenceText,
                this.state.internalReference,
                this.state.invoiceFileName
              )
            }
          >
            <FormattedMessage id="app.panel.setupsourceoffundstab.next"/>
          </Button>
        </div>
      </>
    );
  }
}

export default withUseIntl(SetupSourceOfFundsTab);